module.exports = __webpack_public_path__ + "img/qzsg.d5397c16.jpg";